import { Boq } from "../Boq/Boq.type";
import { Customer } from "../Customer/Customer.type";
import { ApiCallState } from "../Utils";

export type HRPolicy = {
  id: number;
  policy_type: string;
  leave_policy: LeavePolicy;
  overtime_policy: OvertimePolicy;
  allowance_policy: AllowancePolicy;
  description: string;
};

export type LeavePolicy = {
  id: number;
  type: string;
  days: number;
};

export type OvertimePolicy = {
  id: number;
  over_time_hr: number;
};
export type AllowancePolicy = {
  id: number;
  name: string;
  type: string;
  percentage: number;
  amount: number;
  is_default: number;
};

export type HRPolicyStateTypes = {
  fetchAll: ApiCallState<HRPolicy[]>;
};

export const HRPolicyActionTypes = {
  FETCH_ALL_HR_POLICY: "FETCH_ALL_HR_POLICY",
  FETCH_ALL_HR_POLICY_RESET: "FETCH_ALL_HR_POLICY_RESET",
  FETCH_ALL_HR_POLICY_FAILURE: "FETCH_ALL_HR_POLICY_FAILURE",
  FETCH_ALL_HR_POLICY_SUCCESS: "FETCH_ALL_HR_POLICY_SUCCESS",
};
